var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunonline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01 2.2L20 2.201c.916 0 1.683.688 1.792 1.638l.008.163-.003 15.997a1.8 1.8 0 01-1.8 1.8H4A1.799 1.799 0 012.2 20.002v-.332l.234-.234.567.565h-.8l.01-16.001a1.802 1.802 0 011.8-1.799zM3.8 20.018a.2.2 0 00.2.182l15.996-.002a.2.2 0 00.2-.2l.005-15.951-.002-.07a.2.2 0 00-.2-.176H4.013l-.053.006a.201.201 0 00-.148.194l-.01 16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.851 9.305a.8.8 0 111.552.39l-1.26 5a.8.8 0 01-1.55-.39zm-3.417-.37a.8.8 0 111.132 1.13L7.63 12l1.935 1.934a.8.8 0 11-1.132 1.132l-2.5-2.5a.8.8 0 010-1.132zm7.132 0l2.5 2.5a.8.8 0 010 1.13l-2.5 2.5a.8.8 0 11-1.132-1.13L16.37 12l-1.935-1.934a.8.8 0 111.132-1.132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunonline);
export default __webpack_public_path__ + "static/media/runonline.e2a00868.svg";
export { ForwardRef as ReactComponent };